import React from "react";
import { ExternalLink } from "lucide-react";

function getCompetitorMentions(competitor) {
	return Number(competitor.mentions ?? competitor.mention_count ?? 0);
}

function getCompetitorPct(competitor, totalMentions) {
	const raw =
		competitor.share_pct ??
		competitor.share_percent ??
		competitor.percentage ??
		competitor.share;
	if (raw != null && !Number.isNaN(Number(raw))) {
		return Number(raw);
	}
	const mentions = getCompetitorMentions(competitor);
	if (totalMentions > 0 && mentions > 0) {
		return (mentions / totalMentions) * 100;
	}
	return null;
}

export default function CompetitorRow({ competitor, totalMentions = 0 }) {
	const mentions = getCompetitorMentions(competitor);
	const pct = getCompetitorPct(competitor, totalMentions);
	const url = competitor.url ?? competitor.website ?? null;

	return (
		<li className="market-competition__competitor-item">
			<span className="market-competition__competitor-name">
				{url ? (
					<a
						href={url}
						target="_blank"
						rel="noopener noreferrer"
						className="market-competition__competitor-link"
					>
						{competitor.name}
						<ExternalLink className="market-competition__competitor-link-icon" aria-hidden />
					</a>
				) : (
					competitor.name
				)}
			</span>
			<span className="market-competition__competitor-stats">
				{mentions} mentions{pct != null && <> · {pct.toFixed(1)}%</>}
			</span>
		</li>
	);
}

export function getTotalCompetitorMentions(competitors) {
	return (competitors || []).reduce((sum, c) => sum + getCompetitorMentions(c), 0);
}
